<template lang="pug">
	div
		b-row
			b-col(v-for="meeting in meetingsWithUser" :key="meeting.id" cols="12" md="4" xl="4")
				b-card
					b-card-text
						b Описание:
						div {{ meeting.description }}
					b-card-text
						b Участники:
						div(v-for="user in meeting.users")
							| {{ user.last_name }} {{ user.first_name }}
							span(v-if="user.patronymic")  {{ user.patronymic }}
							span(v-if="user.position") , {{ user.position }}
					b-card-text
						b Помещение:
						div {{meeting.hall.title}}
					b-card-text {{ meeting.start_timestamp|dateFormat('HH:MM') }} - {{ meeting.end_timestamp|dateFormat('HH:MM') }}
					b-card-title.mb-0
						b-badge(:variant="meeting.approved?'success':'primary'" ) {{meeting.approved? 'Подтвержден' : 'На модерации'}}

		NothingFound(v-if="meetingsWithUser.length===0" :buttonUrl="`/events-conferences/${eventID}/meetings`" button buttonText="Забронировать помещение")
		b-button(v-else variant="primary" :to="`/events-conferences/${eventID}/meetings`") Забронировать помещение
</template>

<script>
	import { mapActions, mapState } from 'vuex'

	export default {
		name: 'MeetingsTab',
		props: ['_eventID'],
		data: () => ({

		}),
		computed: {
			...mapState(['event','account','myParticipant']),
			...mapState({
				meetings:state=>state.event.meetings,
			}),
			eventID(){ return this.myParticipant.data.event.id },
			meetingsWithUser(){
				return this.meetings.data.filter(item=>item.users.find((item)=>item.id===this.account.data.id))
			}
		},
		methods: {
			...mapActions('event/nested/meetings', ['getEventMeetings']),
		},
	}
</script>
